export default function playVideoPeople() {
    // In pagina possono esserci 1 o più player
    const playerBoxes = document.querySelectorAll(".Video__Player--container");
    if (!playerBoxes.length) return;

    // 1 player YT per box
    const players = new Map();

    // Carica l'API di YouTube una sola volta, poi inizializza tutti i box
    loadYouTubeIframeAPI().then(() => {
        playerBoxes.forEach((box) => initBox(box));
    });

    function initBox(box) {
        // stessi "nomi" ma come classi (scoped dentro il box)
        const playPauseButton = box.querySelector(".customPlayPause");
        const videoContainer = box.querySelector(".videoWithThumb");
        const playButton = box.querySelector(".playButton");
        const container = box.querySelector(".thumbnailContainer");
        const youtubeEl = box.querySelector(".youtubePlayer");

        if (!playButton || !videoContainer || !container || !youtubeEl) return;

        playButton.addEventListener("click", function () {
            const videoId = this.getAttribute("data-videoid");
            if (!videoId) {
                console.error("Errore: ID video non specificato.");
                return;
            }

            // Mostra il loader
            container.classList.add("loading");
            this.querySelector("i")?.classList.add("hidden");
            this.querySelector(".spinner")?.classList.remove("hidden");

            // Carica il lettore YouTube (per questo box)
            if (!players.has(box)) {
                const player = new YT.Player(youtubeEl, {
                    videoId,
                    playerVars: {
                        autoplay: 1,
                        controls: 0,
                        modestbranding: 1,
                        rel: 0,
                        showinfo: 0,
                        fs: 0,
                        playsinline: 1,
                    },
                    events: {
                        onReady: function () {
                            // Quando il video è pronto
                            container.classList.add("hidden");
                            videoContainer.classList.remove("hidden");
                            videoContainer.style.display = "block";
                            playPauseButton?.classList.remove("hidden");
                        },
                        onStateChange: function (event) {
                            if (!playPauseButton) return;

                            if (event.data === YT.PlayerState.PLAYING) {
                                // Nasconde il bottone Play/Pausa quando il video è in esecuzione
                                playPauseButton.style.opacity = "0";
                                videoContainer.classList.remove("paused");
                            } else {
                                // Mostra il bottone Play/Pausa quando il video è in pausa
                                playPauseButton.style.opacity = "1";
                                videoContainer.classList.add("paused");
                            }
                        },
                    },
                });

                players.set(box, player);
            } else {
                // Se esiste già, cambia video
                const player = players.get(box);
                player.loadVideoById(videoId);

                // assicura UI coerente
                container.classList.add("hidden");
                videoContainer.classList.remove("hidden");
                videoContainer.style.display = "block";
                playPauseButton?.classList.remove("hidden");
            }
        });

        // Gestisce Play/Pausa (per questo box)
        if (playPauseButton) {
            playPauseButton.addEventListener("click", function () {
                const player = players.get(box);
                if (!player) return;

                if (player.getPlayerState() === YT.PlayerState.PLAYING) {
                    player.pauseVideo();
                    this.innerHTML = '<i class="fa-solid fa-play"></i>';
                } else {
                    player.playVideo();
                    this.innerHTML = '<i class="fa-solid fa-pause"></i>';
                }
            });
        }
    }

    function loadYouTubeIframeAPI() {
        // Se già pronta
        if (window.YT && window.YT.Player) return Promise.resolve();

        // Se già in caricamento (evita di sovrascrivere callback in altre pagine/script)
        if (window.__ytIframeApiPromise) return window.__ytIframeApiPromise;

        window.__ytIframeApiPromise = new Promise((resolve) => {
            const previous = window.onYouTubeIframeAPIReady;

            window.onYouTubeIframeAPIReady = () => {
                if (typeof previous === "function") previous();
                resolve();
            };

            // Inserisce lo script solo se non presente
            const src = "https://www.youtube.com/iframe_api";
            const existing = document.querySelector(`script[src="${src}"]`);
            if (!existing) {
                const tag = document.createElement("script");
                tag.src = src;
                document.head.appendChild(tag);
            }
        });

        return window.__ytIframeApiPromise;
    }
}
